import { render, staticRenderFns } from "./ZoneMapDetails.vue?vue&type=template&id=80ed17f0&scoped=true&"
import script from "./ZoneMapDetails.vue?vue&type=script&lang=js&"
export * from "./ZoneMapDetails.vue?vue&type=script&lang=js&"
import style0 from "./ZoneMapDetails.vue?vue&type=style&index=0&id=80ed17f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ed17f0",
  null
  
)

export default component.exports